import {DxObjectMapper} from "../../../../dx-core/services/dx-object-mapper.service";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {DxAuthenticationStorageStrategy} from "./dx-authentication-storage-strategy";
import {DxHttpDispatcher} from "../../../../dx-core/services/dx-http-dispatcher.service";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";
import {of, EMPTY} from "rxjs";
import {map, take, catchError} from "rxjs/operators";

@Injectable()
export class DxServerStorageStrategy implements DxAuthenticationStorageStrategy {

  constructor(private _http: DxHttpDispatcher,
              private _mapper: DxObjectMapper,
              private _configService: BdpkConfigService) {
  }

  public store(session: DxUserSession): void {
  }

  public extract(): Observable<DxUserSession> {
    return this._http.get(this._configService.pitSessionStorageService + '/acl/session', {observe: "response"}).pipe(
      take(1),
      map(response => this._mapper.deserialize<DxUserSession>(response.body, DxUserSession))
    );
  }

  public erase(): void {
    this._http.delete(this._configService.pitSessionStorageService + '/acl/session').subscribe();
  }
}
